<template>
  <div>
    <v-runtime-template :template="content"></v-runtime-template>
  </div>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import MailingList from '@/components/MailingList'
import DublabGallery from '@/components/DublabGallery'

export default {
  data: () => ({
    name: 'RuntimeContent'
  }),
  props: {
    content: {
      default: ''
    }
  },
  components: {
    VRuntimeTemplate,
    // eslint-disable-next-line
    MailingList,
    // eslint-disable-next-line
    DublabGallery
  }
};
</script>